import * as React from 'react';
import cx from 'classnames';
import BaseSwiper from '@src/components/swiper/base-swiper';
import wrapStore from '@src/utils/wrap-store';
import Store from './store';
import styles from './index.less';

const TabMenu = ({ store }) => {
  store.use();

  const handleClick = e => {
    const target = e.target;
    const mecha = store.tabList[target.getAttribute('data-swiper-slide-index')];
    mecha?.id && mecha?.id !== store.currentMechaId && store.toMechaPage(mecha.id);
  };

  return (
    <div className={cx(styles.tabMenu)} onClick={handleClick}>
      <div className={styles.leftBtn} data-btn-hover onClick={store.onPrev} />
      <div className={styles.swiperBox}>
        {store.tabList.length ? (
          <BaseSwiper store={store.tabMenuSwiper}>
            {store.tabList.map(item => {
              return (
                <div key={item.id} className={cx(styles.tabMenuItem, { [styles.isActive]: item.isActive })}>
                  <div className={styles.tabNormal} style={{ pointerEvents: 'none', backgroundImage: `url(${item.tabIcon})` }} />
                  <div className={styles.tabActive} style={{ pointerEvents: 'none', backgroundImage: `url(${item.tabActiveIcon})` }} />
                </div>
              );
            })}
          </BaseSwiper>
        ) : null}
      </div>
      <div className={styles.rightBtn} data-btn-hover onClick={store.onNext} />
    </div>
  );
};

export default wrapStore(TabMenu, Store);
